import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    'Plastering & Re-plastering',
    'Skimming',
    'Rendering',
    'Patch Repairs',
    'Plaster Boarding'
  ];

  const areas = [
    'Manchester',
    'Stockport',
    'Cheadle',
    'Bramhall',
    'Sale',
    'Altrincham',
    'Didsbury',
    'Chorlton'
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <a href="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/8k6l7pp4_plasterer%20logo.png" 
                alt="Expert Plasterer Logo"
                className="h-16 w-auto"
              />
            </a>
            <p className="text-slate-400 leading-relaxed mb-6">
              Professional plastering services across Greater Manchester. Quality work, fair prices, and reliable service.
            </p>
            <div className="flex gap-4">
              <a 
                href={`https://wa.me/${businessInfo.whatsapp}?text=Hi%2C%20I%27m%20interested%20in%20getting%20a%20quote%20from%20Expert-Plasterer.`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#services" className="text-slate-400 hover:text-amber-400 transition-colors">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 className="text-lg font-bold mb-6">Areas We Cover</h4>
            <ul className="grid grid-cols-2 gap-3">
              {areas.map((area, index) => (
                <li key={index} className="text-slate-400">
                  {area}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors">
                  <Phone className="w-5 h-5 flex-shrink-0" />
                  {businessInfo.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors">
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span>Greater Manchester<br />& Surrounding Areas</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Clock className="w-5 h-5 flex-shrink-0" />
                <span>Mon - Sat: 8am - 6pm</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Expert Plasterer. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">Privacy Policy</a>
              <a href="#" className="text-slate-500 hover:text-slate-300 text-sm transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
